import type { ButtonCf, CTATypeCF } from '@/types';
import type { PaidLanderFields } from '../PaidLander.types';
import Confirmation from './Confirmation';

export default function FailureStep({
  failureScreenHeader,
  failureScreenDescription,
  failureScreenImage,
  failureScreenImageAltText,
  failureCta,
  isVisible,
  isOnDark = false,
  fixedGrid = false,
  reverseLayout = false,
  hideImageOnMobile = false,
}: PaidLanderFields & { isVisible: boolean }) {
  return (
    <Confirmation
      heading={failureScreenHeader}
      description={failureScreenDescription}
      hideImageOnMobile={hideImageOnMobile}
      imageSrc={failureScreenImage?.[0]?.preview_url}
      imageAltText={failureScreenImageAltText}
      buttonContent={failureCta as CTATypeCF | ButtonCf}
      isOnDark={isOnDark}
      isVisible={isVisible}
      reverseLayout={reverseLayout}
      fixedGrid={fixedGrid}
    />
  );
}
